export enum AuthnSource {
	SSO = 'sso',
	JUniverse = 'juniverse',
	Login = 'login',
	Bypass = 'bypass',
	MagicLink = 'magiclink',
}
